var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../common/useFetch';
import PrizeDistributorService from '../../domain/PrizeDistributorService';
import lottery from '../../lottery';
import gs from '../../styles/style';
import { Errors, Form, Input, Select, SubmitButton } from '../Common/Form';
import DrawMechanismService from '../../domain/DrawMechanismService';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var PrizeSchemeForm = function (_a) {
    var _b;
    var form = _a.form;
    var t = useTranslation()[0];
    var _c = useFetch(function (config) { return PrizeDistributorService.getPrizeDistributors(config); }, {
        initialValue: []
    }), prizeDistributors = _c.data, getPrizeDistributors = _c.get;
    var _d = useFetch(function (config) { return DrawMechanismService.getDrawMechanisms(config); }, {
        onSuccess: function (drawMechanisms) {
            if (!form.values.draw_mechanism) {
                form.setValue('draw_mechanism', drawMechanisms[0]);
            }
        },
        initialValue: []
    }), drawMechanisms = _d.data, getDrawMechanisms = _d.get;
    var addPrize = function () {
        form.appendValue('prizes', {
            matches: []
        });
    };
    var deletePrize = function (prizeIndex) {
        form.spliceValues('prizes', prizeIndex, 1);
    };
    var movePrizeUp = function (prizeIndex) {
        form.moveUpValue('prizes', prizeIndex);
    };
    var movePrizeDown = function (prizeIndex) {
        form.moveDownValue('prizes', prizeIndex);
    };
    var _e = useState(false), showAllPrizes = _e[0], setShowAllPrizes = _e[1];
    var maxPrizes = 100;
    var lineNumberWidth = form.values.prizes.length.toString().length * 8 + 10;
    useEffect(function () {
        getPrizeDistributors();
        getDrawMechanisms();
    }, []);
    var handlePaste = function (event, index) {
        var value = event.clipboardData.getData('text');
        var lines = value.split("\n");
        var prize = form.values.prizes[index];
        var prizes = [];
        lines.forEach(function (line) {
            var title = line.trim();
            var properties = null;
            var quantity = 1;
            var match = line.trim().match(/(.+?)\t+(.+?)(?:\t+(.+?))?$/);
            if (match) {
                title = match[1];
                if (/^\d+$/.test(match[2])) {
                    properties = null;
                    quantity = parseInt(match[2]);
                }
                else {
                    properties = match[2];
                    quantity = parseInt(match[3]) || 1;
                }
            }
            if (title) {
                for (var i = 0; i < quantity; i++) {
                    prizes.push(__assign(__assign({}, prize), { title: title, properties: properties, value: prize.value || 0 }));
                }
            }
        });
        if (prizes.length > 1) {
            event.preventDefault();
            var newPrizes = __spreadArray([], form.values.prizes, true);
            newPrizes.splice.apply(newPrizes, __spreadArray([index, 1], prizes, false));
            form.setValue('prizes', newPrizes);
        }
    };
    var guaranteed = (_b = form.values.draw_mechanism) === null || _b === void 0 ? void 0 : _b.guaranteed;
    return React.createElement(Form, { form: form },
        React.createElement("h4", { className: gs('mb-3') }, t('general')),
        React.createElement("div", { className: gs('card', 'mb-4') },
            React.createElement("div", { className: gs('card-body') },
                React.createElement("div", { className: gs('row', 'mb-4') },
                    React.createElement("div", { className: gs('col-5') },
                        React.createElement("div", { className: gs('form-group', 'mb-0') },
                            React.createElement("label", null, t('title')),
                            React.createElement(Input, __assign({}, form.string('title'), { required: true })),
                            React.createElement(Errors, { attribute: "title", errors: form.getErrors('title') })))),
                React.createElement("div", { className: gs('form-group') },
                    React.createElement("label", null, t('draw_mechanism')),
                    React.createElement("p", { className: gs('text-muted', 'mb-2') }, t('draw_mechanism_description')),
                    React.createElement(Select, __assign({}, form.select('draw_mechanism', drawMechanisms, 'id'), { required: true }), drawMechanisms.map(function (drawMechanism, index) { return (React.createElement("option", { value: index, key: drawMechanism.id }, drawMechanism.title)); })),
                    React.createElement(Errors, { attribute: "draw_mechanism", errors: form.getErrors('draw_mechanism') })))),
        React.createElement("h4", { className: gs('mb-3') }, t('prizes')),
        React.createElement("div", { className: gs('card', 'mb-4') },
            React.createElement("div", { className: gs('card-body') },
                React.createElement("div", { className: gs('row') },
                    React.createElement("div", { className: gs('col-2') },
                        React.createElement("label", null, t('title')),
                        React.createElement("p", { className: gs('text-muted', 'small', 'mb-0') }, t('prize_title_description'))),
                    React.createElement("div", { className: gs('col-2') },
                        React.createElement("label", null, t('properties')),
                        React.createElement("p", { className: gs('text-muted', 'small', 'mb-0') }, t('prize_properties_description'))),
                    React.createElement("div", { className: gs('col-2') },
                        React.createElement("label", null, t('value')),
                        React.createElement("p", { className: gs('text-muted', 'small', 'mb-0') }, t('prize_value_description'))),
                    React.createElement("div", { className: gs('col-3') },
                        React.createElement("label", null, t('matches')),
                        React.createElement("p", { className: gs('text-muted', 'small', 'mb-0') }, t('prize_matches_description'))),
                    React.createElement("div", { className: gs('col-1') },
                        React.createElement("label", null, t('distributor')),
                        React.createElement("p", { className: gs('text-muted', 'small', 'mb-0') }, t('prize_distributor_description')))),
                React.createElement("hr", null),
                form.values.prizes.map(function (prize, prizeIndex) {
                    if (!showAllPrizes && form.values.prizes.length > maxPrizes) {
                        if (prizeIndex === maxPrizes / 2) {
                            return (React.createElement("div", { className: gs('border-top', 'border-bottom', 'py-4', 'mb-3'), style: { paddingLeft: "".concat(lineNumberWidth, "px") }, key: prizeIndex },
                                t('hiding_prizes_x_to_y', {
                                    x: maxPrizes / 2 + 1,
                                    y: form.values.prizes.length - maxPrizes / 2,
                                }),
                                React.createElement("span", { className: gs('text-muted') }, ' · '),
                                React.createElement("a", { href: "", onClick: function (event) { event.preventDefault(); setShowAllPrizes(true); }, role: "button", className: gs('strong') }, t('show_all'))));
                        }
                        if (prizeIndex >= maxPrizes / 2 && prizeIndex < form.values.prizes.length - maxPrizes / 2) {
                            return null;
                        }
                    }
                    return (React.createElement("div", { key: prizeIndex },
                        React.createElement("div", { className: gs('row', 'mb-3') },
                            React.createElement("div", { className: gs('col-2') },
                                React.createElement("div", { className: gs('d-flex', 'align-items-center') },
                                    React.createElement("div", { className: gs('text-muted', 'flex-shrink-0'), style: { width: lineNumberWidth } },
                                        React.createElement("code", null,
                                            React.createElement("small", null, prizeIndex + 1))),
                                    React.createElement("div", { className: gs('form-group', 'mb-0') },
                                        React.createElement(Input, __assign({}, form.string("prizes.".concat(prizeIndex, ".title")), { onPaste: function (event) { return handlePaste(event, prizeIndex); }, required: true })),
                                        React.createElement(Errors, { attribute: "title", errors: form.getErrors("prizes.".concat(prizeIndex, ".title")) })))),
                            React.createElement("div", { className: gs('col-2') },
                                React.createElement("div", { className: gs('form-group', 'mb-0') },
                                    React.createElement(Input, __assign({}, form.string("prizes.".concat(prizeIndex, ".properties")), { required: true })),
                                    React.createElement(Errors, { attribute: "properties", errors: form.getErrors("prizes.".concat(prizeIndex, ".properties")) }))),
                            React.createElement("div", { className: gs('col-2') },
                                React.createElement("div", { className: gs('form-group', 'mb-0') },
                                    React.createElement("div", { className: gs('input-group') },
                                        React.createElement("div", { className: gs('input-group-prepend') },
                                            React.createElement("span", { className: gs('input-group-text') }, "\u20AC")),
                                        React.createElement(Input, __assign({}, form.money("prizes.".concat(prizeIndex, ".value")), { required: true }))),
                                    React.createElement(Errors, { attribute: "value", errors: form.getErrors("prizes.".concat(prizeIndex, ".value")) }))),
                            React.createElement("div", { className: gs('col-3') },
                                guaranteed && React.createElement("div", { className: gs('form-group', 'mb-0') },
                                    React.createElement("div", { className: gs('text-muted', 'my-2') }, t('guaranteed'))),
                                !guaranteed && React.createElement("div", { className: gs('form-group', 'mb-0') },
                                    React.createElement("div", { className: gs('my-2') }, lottery.number_descriptions.map(function (value, matchIndex) { return React.createElement("span", { className: gs('form-check', 'form-check-inline'), key: matchIndex },
                                        React.createElement(Input, __assign({}, form.checklist("prizes.".concat(prizeIndex, ".matches"), matchIndex), { id: "prizes.".concat(prizeIndex, ".matches.").concat(matchIndex) })),
                                        React.createElement("label", { className: gs('form-check-label'), htmlFor: "prizes.".concat(prizeIndex, ".matches.").concat(matchIndex) }, value)); })),
                                    React.createElement(Errors, { attribute: "matches", errors: form.getErrors("prizes.".concat(prizeIndex, ".matches")) }))),
                            React.createElement("div", { className: gs('col-1') },
                                React.createElement("div", { className: gs('form-group', 'mb-0') },
                                    React.createElement(Select, __assign({}, form.select("prizes.".concat(prizeIndex, ".prize_distributor"), prizeDistributors, 'id'), { required: true }),
                                        React.createElement("option", null, t('none')),
                                        prizeDistributors.map(function (prizeDistributor, index) { return (React.createElement("option", { value: index, key: prizeDistributor.id }, prizeDistributor.title)); })),
                                    React.createElement(Errors, { attribute: "prize_distributor", errors: form.getErrors("prizes.".concat(prizeIndex, ".prize_distributor")) }))),
                            React.createElement("div", { className: gs('col-2', 'my-1', 'text-right') },
                                React.createElement("div", { className: gs('btn-group') },
                                    React.createElement("button", { type: "button", onClick: function () { return movePrizeUp(prizeIndex); }, disabled: prizeIndex === 0, className: gs('btn', 'btn-sm', 'btn-outline-secondary') },
                                        React.createElement("small", null,
                                            React.createElement(FontAwesomeIcon, { icon: "arrow-up" }))),
                                    ' ',
                                    React.createElement("button", { type: "button", onClick: function () { return movePrizeDown(prizeIndex); }, disabled: prizeIndex === form.values.prizes.length - 1, className: gs('btn', 'btn-sm', 'btn-outline-secondary') },
                                        React.createElement("small", null,
                                            React.createElement(FontAwesomeIcon, { icon: "arrow-down" })))),
                                ' ',
                                React.createElement("button", { type: "button", onClick: function () { return deletePrize(prizeIndex); }, className: gs('btn', 'btn-sm', 'btn-outline-danger') },
                                    React.createElement("small", null,
                                        React.createElement(FontAwesomeIcon, { icon: "trash" })))))));
                }),
                React.createElement("hr", { className: gs('mt-0') }),
                React.createElement("button", { type: "button", onClick: addPrize, className: gs('btn', 'btn-secondary') }, t('add_prize')))),
        React.createElement("div", { className: gs('text-right') },
            React.createElement(SubmitButton, { form: form, className: gs('btn-lg') }, t('save'))));
};
export default PrizeSchemeForm;
